import request from '../commons';
import { API } from '..';

function getIntegrations() {
  const req = request.get(API.config.batman)('public/alert-sources');
  return req;
}

export { getIntegrations };
